import TenantChange from './tenant-change.vue';

export default TenantChange;
